export default __webpack_public_path__ + "static/black-c03a03994f3f2a0f5560633f337c0719.jpg";